import { jsx as u } from "react/jsx-runtime";
import { useState as f, useCallback as n, useEffect as c } from "react";
import { Select as i } from "../select/Select.component.js";
const r = [
  {
    value: !0,
    label: "True"
  },
  { value: !1, label: "False" }
], v = ({ onInput: e, value: a }) => {
  const [s, t] = f(null), o = n(
    (l) => {
      l && (e == null || e(l.value));
    },
    [e]
  );
  return c(() => {
    t(r.find((l) => l.value === a) ?? null);
  }, [a]), /* @__PURE__ */ u(
    i,
    {
      options: r,
      isSearchable: !1,
      onChange: o,
      value: s
    }
  );
};
export {
  v as BooleanInput
};
